/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export { TeamTag} from "./TeamTag";
